export const engCategories = [
  "All",
  "Mech.",
  "Piping",
  "Struc.",
  "Inst.",
  "Elec.",
];
